import React from "react";
import "../Curso.css";

function CursoInfoForm({ curso }) {
  if (!curso) {
    return <div>Cargando...</div>;
  }

  return (
    <div className="curso-info">
      <h5>Coordinación</h5>

      <div className="curso-info-row">
        <div className="curso-info-label">
          <strong>Jefe/a Proyecto:</strong>
        </div>
        <div className="curso-info-data">
          {curso.jefe && curso.jefe.nombre ? curso.jefe.nombre : "-----"}
        </div>
      </div>

      <div className="curso-info-row">
        <div className="curso-info-label">
          <strong>Coordinación:</strong>
        </div>
        <div className="curso-info-data">
          {curso.coordinador && curso.coordinador.nombre
            ? curso.coordinador.nombre
            : "-----"}
        </div>
      </div>

      <div className="curso-info-row">
        <div className="curso-info-label">
          <strong>Psicólog@:</strong>
        </div>
        <div className="curso-info-data">
          {curso.psicologa && curso.psicologa.nombre
            ? curso.psicologa.nombre
            : "-----"}
        </div>
      </div>

      <h5>Empresas</h5>

      <div className="curso-info-row">
        <div className="curso-info-label">
          <strong>Empresas:</strong>
        </div>
        <div className="curso-info-data">
          {curso.empresa && curso.empresa.length > 0
            ? curso.empresa.map((empresa, index) => (
                <span key={empresa.id}>
                  {empresa.nombre}
                  {index < curso.empresa.length - 1 ? ", " : ""}
                </span>
              ))
            : "-----"}
        </div>
      </div>

      <div className="curso-info-row">
        <div className="curso-info-label">
          <strong>Otecs:</strong>
        </div>
        <div className="curso-info-data">
          {curso.otec && curso.otec.length > 0
            ? curso.otec.map((otec, index) => (
                <span key={otec.id}>
                  {otec.nombre}
                  {index < curso.otec.length - 1 ? ", " : ""}
                </span>
              ))
            : "-----"}
        </div>
      </div>

      <div className="curso-info-row">
        <div className="curso-info-label">
          <strong>Asociados:</strong>
        </div>
        <div className="curso-info-data">
          {curso.asociado && curso.asociado.length > 0
            ? curso.asociado.map((asociado, index) => (
                <span key={asociado.id}>
                  {asociado.nombre}
                  {index < curso.asociado.length - 1 ? ", " : ""}
                </span>
              ))
            : "-----"}
        </div>
      </div>
    </div>
  );
}

export default CursoInfoForm;
